module.exports = __webpack_public_path__ + "img/bg13.582dfe71.png";